module.exports = __webpack_public_path__ + "img/ic_help.79eb459b.svg";